module.exports = __webpack_public_path__ + "img/registerLogin.40f222bd.png";